// frontend/src/pages/Admin.js
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './Admin.css';
import ShopAdmin from './admin/ShopAdmin';
import SummaryTab from './Admin/components/SummaryTab';
import ExportTab from './Admin/components/ExportTab';


const API_URL = process.env.REACT_APP_API_URL || 'https://moyobed.pro';

function Admin({ user, darkMode, toggleTheme }) {
  const [activeTab, setActiveTab] = useState('summary');
  const [newComplaints, setNewComplaints] = useState(0);
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem('moyobed_user');
    localStorage.removeItem('token');
    window.location.href = '/';
  };

  return (
    <div className="page admin-page">
      <header className="admin-header">
        <div className="header-left">
          <h1 className="page-title">⚙️ Админ-панель</h1>
          <p className="user-name">{user.full_name}</p>
        </div>
        <div className="header-right">
          <button className="btn btn-sm btn-outline theme-toggle" onClick={toggleTheme}>
            {darkMode ? '☀️' : '🌙'}
          </button>
          <button className="btn btn-sm btn-outline" onClick={handleLogout}>
            🚪 Выйти
          </button>
        </div>
      </header>

      <div className="tabs">
        <button className={`tab-btn ${activeTab === 'upload' ? 'active' : ''}`} onClick={() => setActiveTab('upload')}>
          <span className="tab-icon">📤</span>
          <span className="tab-label">Загрузка</span>
        </button>
        <button className={`tab-btn ${activeTab === 'summary' ? 'active' : ''}`} onClick={() => setActiveTab('summary')}>
          <span className="tab-icon">📊</span>
          <span className="tab-label">Сводка</span>
        </button>
        <button className={`tab-btn ${activeTab === 'complaints' ? 'active' : ''}`} onClick={() => setActiveTab('complaints')}>
          <span className="tab-icon">💬</span>
          <span className="tab-label">Жалобы</span>
        </button>
        <button className={`tab-btn ${activeTab === 'stickers' ? 'active' : ''}`} onClick={() => setActiveTab('stickers')}>
          <span className="tab-icon">🏷️</span>
          <span className="tab-label">Наклейки</span>
        </button>
        <button className={`tab-btn ${activeTab === 'export' ? 'active' : ''}`} onClick={() => setActiveTab('export')}>
          <span className="tab-icon">📥</span>
          <span className="tab-label">Выгрузка</span>
        </button>
        <button className={`tab-btn ${activeTab === 'employees' ? 'active' : ''}`} onClick={() => setActiveTab('employees')}>
          <span className="tab-icon">👥</span>
          <span className="tab-label">Сотрудники</span>
        </button>
        <button className={`tab-btn ${activeTab === 'branches' ? 'active' : ''}`} onClick={() => setActiveTab('branches')}>
          <span className="tab-icon">🏢</span>
          <span className="tab-label">Филиалы</span>
        </button>
        <button className={`tab-btn ${activeTab === 'shop' ? 'active' : ''}`} onClick={() => setActiveTab('shop')}>
          <span className="tab-icon">🛍️</span>
          <span className="tab-label">Магазин</span>
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'upload' && <UploadTab companyId={user.company_id} />}
        {activeTab === 'summary' && <SummaryTab companyId={user.company_id} />}
        {activeTab === 'complaints' && <ComplaintsTab companyId={user.company_id} onCountChange={setNewComplaints} />}
        {activeTab === 'stickers' && <StickersTab companyId={user.company_id} />}
        {activeTab === 'export' && <ExportTab companyId={user.company_id} />}
        {activeTab === 'employees' && <EmployeesTab companyId={user.company_id} />}
        {activeTab === 'branches' && <BranchesTab companyId={user.company_id} />}
        {activeTab === 'shop' && <ShopAdmin companyId={user.company_id} />}
      </div>
    </div>
  );
}

// ======================== ЗАГРУЗКА ========================
function UploadTab({ companyId }) {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [deadline, setDeadline] = useState('');
  const [deleting, setDeleting] = useState(false);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) { setError('Выберите файл'); return; }
    setUploading(true); setError(''); setResult(null);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('company_id', companyId);
      if (deadline) formData.append('deadline', deadline);
      const response = await axios.post(`${API_URL}/api/admin/upload-menu`, formData);
      setResult(response.data);
      setFile(null);
      document.getElementById('excel-input').value = '';
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка загрузки');
    } finally { setUploading(false); }
  };

  const handleDeleteMenu = async () => {
    if (!window.confirm('Вы уверены? Все меню и заказы будут удалены!')) return;
    setDeleting(true); setError(''); setResult(null);
    try {
      const response = await axios.delete(`${API_URL}/api/admin/menu`, { params: { company_id: companyId } });
      setResult({ status: 'success', message: response.data.message });
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка удаления');
    } finally { setDeleting(false); }
  };

  return (
    <div className="tab-panel">
      <h2 className="tab-title">📤 Загрузка меню (Excel)</h2>
      <form onSubmit={handleUpload} className="card upload-form">
        <p className="form-hint">Загрузите Excel-файл с листом "Меню".</p>
        <label className="input-label">Дедлайн заказа (необязательно)</label>
        <input type="datetime-local" className="input" value={deadline} onChange={(e) => setDeadline(e.target.value)} style={{ marginBottom: 16 }} />
        <div className="file-upload-zone">
          <input type="file" accept=".xlsx,.xls" onChange={(e) => setFile(e.target.files[0])} id="excel-input" className="file-input-hidden" />
          <label htmlFor="excel-input" className="file-label">
            {file ? <div className="file-selected"><span>📄</span><span>{file.name}</span></div>
              : <div className="file-placeholder"><span>📁</span><span>Выбрать Excel-файл</span><span className="file-formats">.xlsx, .xls</span></div>}
          </label>
        </div>
        {error && <div className="error-message" style={{ whiteSpace: 'pre-line' }}>{error}</div>}
        {result && <div className="success-message">✅ {result.message}{result.dishes_created && <><br />Блюд: {result.dishes_created}, записей: {result.menu_items_created}</>}{result.date_range && <><br />Период: {result.date_range}</>}</div>}
        <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
          <button type="submit" className={`btn upload-btn ${uploading ? 'loading' : ''}`} disabled={uploading || !file} style={{ flex: 1 }}>
            {uploading ? <span className="spinner"></span> : '📤 Загрузить меню'}
          </button>
          <button type="button" className={`btn btn-danger ${deleting ? 'loading' : ''}`} onClick={handleDeleteMenu} disabled={deleting}>
            {deleting ? <span className="spinner"></span> : '🗑️ Удалить'}
          </button>
        </div>
      </form>
    </div>
  );
}

// ======================== СВОДКА ========================

// ======================== ЖАЛОБЫ ========================
function ComplaintsTab({ companyId, onCountChange }) {
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('');

  const fetchComplaints = useCallback(async () => {
    setLoading(true);
    try {
      const params = { company_id: companyId };
      if (statusFilter) params.status = statusFilter;
      const response = await axios.get(`${API_URL}/api/admin/complaints`, { params });
      setComplaints(response.data);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, [companyId, statusFilter]);

  const fetchCount = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/admin/complaints/count`, { params: { company_id: companyId } });
      onCountChange(response.data.new_complaints);
    } catch (err) {}
  }, [companyId, onCountChange]);

  useEffect(() => { fetchComplaints(); fetchCount(); }, [fetchComplaints, fetchCount]);

  const updateStatus = async (complaintId, newStatus) => {
    const formData = new FormData();
    formData.append('status', newStatus);
    await axios.patch(`${API_URL}/api/admin/complaints/${complaintId}/status`, formData);
    fetchComplaints(); fetchCount();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить жалобу навсегда?')) return;
    try {
      await axios.delete(`${API_URL}/api/admin/complaints/${id}`);
      fetchComplaints(); fetchCount();
    } catch (err) { console.error(err); }
  };

  return (
    <div className="tab-panel">
      <h2 className="tab-title">💬 Жалобы</h2>
      <div className="filter-row" style={{ marginBottom: 16, flexWrap: 'wrap' }}>
        {['', 'new', 'in_progress', 'resolved', 'archived'].map(status => (
          <button key={status} className={`btn btn-sm ${statusFilter === status ? '' : 'btn-outline'}`} onClick={() => setStatusFilter(status)}>
            {status === '' ? 'Все' : status === 'new' ? 'Новые' : status === 'in_progress' ? 'В работе' : 'Решено'}
          </button>
        ))}
      </div>
      {loading ? <div className="loading-screen"><div className="loading-spinner"></div></div>
        : complaints.length === 0 ? <div className="empty-state card"><p>📭 Жалоб нет</p></div>
        : <div className="complaints-list">
          {complaints.map(c => (
            <div key={c.id} className={`card complaint-card status-${c.status}`}>
              <div className="complaint-meta">
                <span className="complaint-author">{c.employee_name}</span>
                <span className="complaint-date">{new Date(c.created_at).toLocaleString('ru-RU')}</span>
                <span className={`status-badge status-${c.status}`}>{c.status === 'new' ? 'Новая' : c.status === 'in_progress' ? 'В работе' : 'Решено'}</span>
              </div>
              <p className="complaint-text">{c.complaint_text}</p>
              {c.photo_path && <img src={`${API_URL}${c.photo_path}`} alt="Фото" className="complaint-photo" onClick={() => window.open(`${API_URL}${c.photo_path}`, '_blank')} />}
              <div className="complaint-actions">
                {c.status === 'new' && (
                  <button className="btn btn-sm" onClick={() => updateStatus(c.id, 'in_progress')}>🔧 В работу</button>
                )}
                {c.status === 'in_progress' && (
                  <button className="btn btn-sm" onClick={() => updateStatus(c.id, 'resolved')}>✅ Решено</button>
                )}
                {c.status === 'new' && (
                  <button className="btn btn-sm btn-outline" onClick={() => updateStatus(c.id, 'archived')}>📁 Архив</button>
                )}
                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(c.id)}>🗑️</button>
              </div>
            </div>
          ))}
        </div>}
    </div>
  );
}

// ======================== НАКЛЕЙКИ ========================
function StickersTab({ companyId }) {
  const [date, setDate] = useState('');
  const [generating, setGenerating] = useState(false);
  const [generatingAll, setGeneratingAll] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfUrlAll, setPdfUrlAll] = useState(null);
  const [error, setError] = useState('');
  const [resultInfo, setResultInfo] = useState(null);

  const handleGenerate = async () => {
    if (!date) { setError('Выберите дату'); return; }
    setGenerating(true); setError(''); setPdfUrl(null);
    try {
      const formData = new FormData();
      formData.append('company_id', companyId);
      formData.append('date', date);
      const response = await axios.post(`${API_URL}/api/admin/generate-stickers`, formData);
      setPdfUrl(`${API_URL}${response.data.pdf_url}`);
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка');
    } finally { setGenerating(false); }
  };

  const handleGenerateAllDays = async () => {
    setGeneratingAll(true); setError(''); setPdfUrlAll(null); setResultInfo(null);
    try {
      const formData = new FormData();
      formData.append('company_id', companyId);
      const response = await axios.post(`${API_URL}/api/admin/generate-stickers-all-days`, formData);
      setPdfUrlAll(`${API_URL}${response.data.pdf_url}`);
      setResultInfo({
        orders: response.data.orders_count,
        dates: response.data.dates_count
      });
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка');
    } finally { setGeneratingAll(false); }
  };

  return (
    <div className="tab-panel">
      <h2 className="tab-title">🏷️ Наклейки</h2>
      
      <div className="card">
        <h3>📅 По дате</h3>
        <p className="form-hint">Создаёт PDF с наклейками для выбранной даты (3×7 на A4).</p>
        <div className="filter-row" style={{ marginTop: 16 }}>
          <input type="date" className="input" value={date} onChange={(e) => setDate(e.target.value)} />
          <button className={`btn ${generating ? 'loading' : ''}`} onClick={handleGenerate} disabled={generating}>
            {generating ? <span className="spinner"></span> : '🏷️ Создать PDF'}
          </button>
        </div>
        {pdfUrl && (
          <div className="success-message" style={{ marginTop: 12 }}>
            ✅ PDF готов!<br />
            <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className="btn btn-sm" style={{ marginTop: 8, display: 'inline-flex' }}>
              📄 Открыть PDF
            </a>
          </div>
        )}
      </div>

      <div className="card" style={{ borderColor: 'var(--primary)' }}>
        <h3>📆 За все дни</h3>
        <p className="form-hint">Создаёт один PDF с наклейками для ВСЕХ дней, на которые есть заказы.</p>
        <div className="filter-row" style={{ marginTop: 16 }}>
          <button 
            className={`btn btn-success ${generatingAll ? 'loading' : ''}`} 
            onClick={handleGenerateAllDays} 
            disabled={generatingAll}
            style={{ background: 'linear-gradient(135deg, #10b981, #059669)' }}
          >
            {generatingAll ? <span className="spinner"></span> : '📆 Создать PDF за все дни'}
          </button>
        </div>
        {resultInfo && (
          <div className="success-message" style={{ marginTop: 12 }}>
            ✅ PDF готов! <br />
            📊 {resultInfo.dates} дней, {resultInfo.orders} наклеек
          </div>
        )}
        {pdfUrlAll && (
          <div className="success-message" style={{ marginTop: 12 }}>
            <a href={pdfUrlAll} target="_blank" rel="noopener noreferrer" className="btn btn-sm" style={{ display: 'inline-flex' }}>
              📄 Открыть PDF
            </a>
          </div>
        )}
      </div>

      {error && <div className="error-message">{error}</div>}
    </div>
  );
}

// ======================== ВЫГРУЗКА ========================

// ======================== СОТРУДНИКИ (ПЛИТКИ ПО 3 В РЯД) ========================
function EmployeesTab({ companyId }) {
  const [employees, setEmployees] = useState([]);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastName, setLastName] = useState('');
  const [initials, setInitials] = useState('');
  const [phone, setPhone] = useState('');
  const [pin, setPin] = useState('');
  const [branchId, setBranchId] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [uploadResult, setUploadResult] = useState(null);
  const fileRef = useRef(null);

  const [editingEmployee, setEditingEmployee] = useState(null);
  const [editForm, setEditForm] = useState({
    id: '',
    last_name: '',
    initials: '',
    phone: '',
    pin: '',
    branch_id: ''
  });
  const [showEditModal, setShowEditModal] = useState(false);

  const fetchEmployees = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/admin/employees`, { params: { company_id: companyId } });
      setEmployees(response.data);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, [companyId]);

  const fetchBranches = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/admin/branches`, { params: { company_id: companyId } });
      setBranches(response.data);
    } catch (err) { console.error(err); }
  }, [companyId]);

  useEffect(() => { 
    fetchEmployees(); 
    fetchBranches(); 
  }, [fetchEmployees, fetchBranches]);

  const handleToggleAdmin = async (id) => {
    await axios.patch(`${API_URL}/api/admin/employees/${id}/admin`);
    fetchEmployees();
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (!lastName || !phone || !pin || pin.length !== 4) {
      setError('Фамилия, телефон и пин (4 цифры) обязательны');
      return;
    }
    try {
      const formData = new FormData();
      formData.append('company_id', companyId);
      formData.append('last_name', lastName);
      formData.append('initials', initials);
      formData.append('phone', phone);
      formData.append('pin', pin);
      if (branchId) formData.append('branch_id', branchId);
      
      const response = await axios.post(`${API_URL}/api/admin/employees`, formData);
      setSuccess(`✅ Добавлен: ${response.data.full_name}, пин: ${response.data.pin}`);
      setLastName(''); setInitials(''); setPhone(''); setPin(''); setBranchId('');
      fetchEmployees();
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка');
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setError(''); setUploadResult(null);
    try {
      const formData = new FormData();
      formData.append('company_id', companyId);
      formData.append('file', file);
      const response = await axios.post(`${API_URL}/api/admin/employees/upload`, formData);
      setUploadResult(response.data);
      fetchEmployees();
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка загрузки');
    }
    fileRef.current.value = '';
  };

  const handleExport = async () => {
    try {
      const formData = new FormData();
      formData.append('company_id', companyId);
      const response = await axios.post(`${API_URL}/api/admin/employees/export`, formData);
      window.open(`${API_URL}${response.data.download_url}`, '_blank');
    } catch (err) {
      setError('Ошибка выгрузки');
    }
  };

  const handleDownloadTemplate = async () => {
    try {
      window.open(`${API_URL}/api/admin/employees/template`, '_blank');
    } catch (err) {
      setError('Ошибка скачивания шаблона');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить сотрудника и все его заказы?')) return;
    await axios.delete(`${API_URL}/api/admin/employees/${id}`);
    fetchEmployees();
  };

  const openEditModal = (emp) => {
    setEditingEmployee(emp);
    setEditForm({
      id: emp.id,
      last_name: emp.last_name || '',
      initials: emp.initials || '',
      phone: emp.phone || '',
      pin: emp.pin || '',
      branch_id: emp.branch_id || ''
    });
    setShowEditModal(true);
    setError('');
    setSuccess('');
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditingEmployee(null);
    setEditForm({ id: '', last_name: '', initials: '', phone: '', pin: '', branch_id: '' });
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    
    if (!editForm.last_name || !editForm.phone || !editForm.pin || editForm.pin.length !== 4) {
      setError('Фамилия, телефон и пин (4 цифры) обязательны');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('company_id', companyId);
      formData.append('last_name', editForm.last_name);
      formData.append('initials', editForm.initials);
      formData.append('phone', editForm.phone);
      formData.append('pin', editForm.pin);
      if (editForm.branch_id) formData.append('branch_id', editForm.branch_id);

      await axios.put(`${API_URL}/api/admin/employees/${editForm.id}`, formData);
      setSuccess('✅ Сотрудник обновлён');
      fetchEmployees();
      setTimeout(() => {
        closeEditModal();
      }, 1500);
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка обновления');
    }
  };

  if (loading) return <div className="loading-screen"><div className="loading-spinner"></div></div>;

  return (
    <div className="tab-panel">
      <h2 className="tab-title">👥 Сотрудники</h2>
      
      <form onSubmit={handleAdd} className="card" style={{ marginBottom: 16 }}>
        <h3>➕ Добавить одного</h3>
        <div className="filter-row" style={{ marginTop: 12, flexWrap: 'wrap' }}>
          <input className="input" placeholder="Фамилия" value={lastName} onChange={e => setLastName(e.target.value)} style={{ flex: 2, minWidth: 100 }} />
          <input className="input" placeholder="И.О. (АА)" value={initials} onChange={e => setInitials(e.target.value.toUpperCase().replace(/[^А-Я]/g, ''))} style={{ flex: 1, minWidth: 60 }} />
          <input className="input" placeholder="Телефон" value={phone} onChange={e => setPhone(e.target.value)} style={{ flex: 2, minWidth: 130 }} />
          <input className="input" placeholder="Пин (4 цифры)" value={pin} onChange={e => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))} maxLength={4} style={{ flex: 1, minWidth: 80 }} />
          <select className="input select-input" value={branchId} onChange={e => setBranchId(e.target.value)} style={{ flex: 2, minWidth: 150 }}>
            <option value="">Без филиала</option>
            {branches.map(b => (
              <option key={b.id} value={b.id}>{b.name}</option>
            ))}
          </select>
          <button type="submit" className="btn btn-sm">➕</button>
        </div>
      </form>

      <div className="card" style={{ marginBottom: 16 }}>
        <h3>📥 Загрузить из Excel</h3>
        <p className="form-hint">Колонка A: Фамилия И.О.<br />Колонка B: Телефон<br />Колонка C: Пин (4 цифры)</p>
        <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
          <input type="file" accept=".xlsx,.xls" ref={fileRef} onChange={handleFileUpload} style={{ flex: 1 }} />
        </div>
        {uploadResult && (
          <div className="success-message" style={{ marginTop: 8 }}>
            ✅ Добавлено: {uploadResult.created}, пропущено: {uploadResult.skipped}
          </div>
        )}
      </div>

      <button className="btn btn-outline" onClick={handleExport} style={{ marginBottom: 16, width: '100%' }}>
        📥 Выгрузить список (Excel)
      </button>

      <button className="btn btn-outline" onClick={handleDownloadTemplate} style={{ marginBottom: 16, width: '100%' }}>
        📄 Скачать шаблон для загрузки
      </button>
      
      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}

      {/* ПЛИТКИ СОТРУДНИКОВ ПО 3 В РЯД */}
      <div className="employees-grid">
        {employees.length === 0 ? (
          <div className="empty-state card" style={{ gridColumn: '1 / -1' }}>
            <p>Нет сотрудников</p>
          </div>
        ) : (
          employees.map(emp => (
            <div key={emp.id} className="employee-card card">
              <div className="employee-avatar">
                {emp.initials || emp.last_name?.charAt(0) || '👤'}
              </div>
              <div className="employee-name">
                {emp.last_name} {emp.initials}
              </div>
              <div className="employee-phone">
                {emp.phone}
              </div>
              <div className="employee-badges">
                {emp.branch_name && (
                  <span className="employee-badge employee-badge-branch">
                    🏢 {emp.branch_name}
                  </span>
                )}
                {emp.is_admin && (
                  <span className="employee-badge employee-badge-admin">Админ</span>
                )}
              </div>
              <div className="employee-actions">
                <button className="btn btn-sm btn-outline" onClick={() => openEditModal(emp)}>
                  ✏️
                </button>
                <button className="btn btn-sm btn-outline" onClick={() => handleToggleAdmin(emp.id)}>
                  {emp.is_admin ? '👑' : '⬆️'}
                </button>
                {!emp.is_admin && (
                  <button className="btn btn-sm btn-danger" onClick={() => handleDelete(emp.id)}>🗑️</button>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      {/* Модальное окно редактирования */}
      {showEditModal && (
        <div className="modal-overlay" onClick={closeEditModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>✏️ Редактировать сотрудника</h3>
            <form onSubmit={handleEditSubmit}>
              <div className="filter-row" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '8px' }}>
                <input 
                  className="input" 
                  placeholder="Фамилия" 
                  value={editForm.last_name} 
                  onChange={e => setEditForm({...editForm, last_name: e.target.value})} 
                  required 
                />
                <input 
                  className="input" 
                  placeholder="И.О. (АА)" 
                  value={editForm.initials} 
                  onChange={e => setEditForm({...editForm, initials: e.target.value.toUpperCase().replace(/[^А-Я]/g, '')})} 
                />
                <input 
                  className="input" 
                  placeholder="Телефон" 
                  value={editForm.phone} 
                  onChange={e => setEditForm({...editForm, phone: e.target.value})} 
                  required 
                />
                <input 
                  className="input" 
                  placeholder="Пин (4 цифры)" 
                  value={editForm.pin} 
                  onChange={e => setEditForm({...editForm, pin: e.target.value.replace(/\D/g, '').slice(0, 4)})} 
                  maxLength="4" 
                  required 
                />
                <select 
                  className="input select-input" 
                  value={editForm.branch_id} 
                  onChange={e => setEditForm({...editForm, branch_id: e.target.value})}
                >
                  <option value="">Без филиала</option>
                  {branches.map(b => (
                    <option key={b.id} value={b.id}>{b.name}</option>
                  ))}
                </select>
              </div>
              {error && <div className="error-message" style={{ marginTop: 8 }}>{error}</div>}
              {success && <div className="success-message" style={{ marginTop: 8 }}>{success}</div>}
              <div className="modal-actions" style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
                <button type="submit" className="btn">💾 Сохранить</button>
                <button type="button" className="btn btn-outline" onClick={closeEditModal}>❌ Отмена</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

// ======================== ФИЛИАЛЫ (КЛИКАБЕЛЬНЫЕ ПЛИТКИ) ========================
function BranchesTab({ companyId }) {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const fetchBranches = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get(`${API_URL}/api/admin/branches`, { 
        params: { company_id: companyId } 
      });
      console.log('✅ Филиалы получены:', response.data);
      setBranches([...response.data]);
    } catch (err) {
      console.error('❌ Ошибка загрузки филиалов:', err);
      setError('Ошибка загрузки филиалов: ' + (err.response?.data?.detail || err.message));
    } finally { 
      setLoading(false); 
    }
  }, [companyId]);

  useEffect(() => { 
    fetchBranches(); 
  }, [fetchBranches]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); 
    setSuccess('');
    
    if (!name || !address) {
      setError('Название и адрес обязательны');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('company_id', companyId);
      formData.append('name', name);
      formData.append('address', address);

      if (editingId) {
        await axios.put(`${API_URL}/api/admin/branches/${editingId}`, formData);
        setSuccess('✅ Филиал обновлен');
      } else {
        await axios.post(`${API_URL}/api/admin/branches`, formData);
        setSuccess('✅ Филиал создан');
      }
      
      setName(''); 
      setAddress(''); 
      setEditingId(null);
      await fetchBranches();
      
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка');
    }
  };

  const handleEdit = (branch) => {
    setEditingId(branch.id);
    setName(branch.name);
    setAddress(branch.address);
    setError('');
    setSuccess('');
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setName('');
    setAddress('');
    setError('');
    setSuccess('');
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`🗑️ Удалить филиал "${name}"?`)) return;
    
    try {
      await axios.delete(`${API_URL}/api/admin/branches/${id}`);
      setSuccess(`✅ Филиал "${name}" удален`);
      await fetchBranches();
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка удаления');
    }
  };

  if (loading) {
    return <div className="loading-screen"><div className="loading-spinner"></div></div>;
  }

  return (
    <div className="tab-panel">
      <h2 className="tab-title">🏢 Филиалы</h2>

      <form onSubmit={handleSubmit} className="card" style={{ marginBottom: 16 }}>
        <h3>{editingId ? '✏️ Редактировать филиал' : '➕ Добавить филиал'}</h3>
        <div className="filter-row" style={{ marginTop: 12, flexWrap: 'wrap' }}>
          <input 
            className="input" 
            placeholder="Название филиала" 
            value={name} 
            onChange={e => setName(e.target.value)} 
            style={{ flex: 2, minWidth: 150 }} 
            required
          />
          <input 
            className="input" 
            placeholder="Адрес" 
            value={address} 
            onChange={e => setAddress(e.target.value)} 
            style={{ flex: 3, minWidth: 200 }} 
            required
          />
          <button type="submit" className="btn">
            {editingId ? '💾 Сохранить' : '➕ Добавить'}
          </button>
          {editingId && (
            <button type="button" className="btn btn-outline" onClick={handleCancelEdit}>
              ❌ Отмена
            </button>
          )}
        </div>
        {error && <div className="error-message" style={{ marginTop: 8 }}>{error}</div>}
        {success && <div className="success-message" style={{ marginTop: 8 }}>{success}</div>}
      </form>

      <div className="branches-list">
        {branches.map((branch) => (
          <div key={branch.id} className="card branch-item" style={{ cursor: 'pointer' }}>
            <Link to={`/branch/${branch.id}`} style={{ textDecoration: 'none', color: 'inherit', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px' }}>
              <div className="branch-info">
                <strong className="branch-name">{branch.name}</strong>
                <br />
                <span className="branch-address" style={{ color: 'var(--text-light)', fontSize: '13px' }}>
                  📍 {branch.address}
                </span>
                {branch.employee_count !== undefined && (
                  <>
                    <br />
                    <span style={{ fontSize: '12px', color: 'var(--text-light)' }}>
                      👥 Сотрудников: <strong>{branch.employee_count}</strong>
                    </span>
                  </>
                )}
              </div>
              <div className="branch-actions" style={{ display: 'flex', gap: 6 }}>
                <button 
                  className="btn btn-sm btn-outline" 
                  onClick={(e) => { e.stopPropagation(); handleEdit(branch); }}
                  title="Редактировать"
                >
                  ✏️
                </button>
                <button 
                  className="btn btn-sm btn-danger" 
                  onClick={(e) => { e.stopPropagation(); handleDelete(branch.id, branch.name); }}
                  title="Удалить"
                >
                  🗑️
                </button>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Admin;